export {
  TextContent as default,
  TextContent,
  TextContentHeadline,
  TextContentParagraph,
} from './TextContent';
